export default __webpack_public_path__ + "static/media/thumbnail.45ddd2f8.png";